/**
 * Linear Assets — Vegetation Clearance Efficacy (Step 8.6)
 */

import React, { useState } from 'react';
import { TrendingUp, RefreshCw, CheckCircle2, Shield, Calendar } from 'lucide-react';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';

export const LinearEfficacyPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
            <TrendingUp className="w-7 h-7 text-amber-500" /> Clearance Efficacy &amp; Growth Retardation (Step 8.6)
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Post-clearance drone &amp; satellite verification comparing pre-trimming LiDAR envelopes with post-trimming regrowth
          </p>
        </div>
      </div>

      <div className="space-y-4">
        {[
          { corridor: 'Highland Grid Interconnector (PL-12)', km: '85.1', preClearance: '3.9m', postClearance: '9.8m', efficacy: '100% Cleared (Zero Breach)', date: '2026-08-14' },
          { corridor: 'Main Western Rail Line (Sector B)', km: '48.2', preClearance: 'Obstruction', postClearance: '12.0m', efficacy: 'Track Reopened to Full Speed', date: '2026-08-15' },
        ].map((item, i) => (
          <Card key={i} className="p-4 border-l-4 border-green-500">
            <div className="flex items-center justify-between mb-2">
              <h3 className="font-bold text-sm text-gray-900 dark:text-white">{item.corridor} &bull; Km {item.km}</h3>
              <span className="px-2 py-0.5 rounded bg-green-100 text-green-700 font-bold text-[10px] uppercase">
                {item.efficacy}
              </span>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-xs text-gray-600 dark:text-gray-400 mt-2">
              <p>Pre-Intervention: <strong>{item.preClearance}</strong></p>
              <p>Current Clearance: <strong className="text-green-600">{item.postClearance}</strong></p>
              <p>Verified On: <strong>{item.date}</strong></p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default LinearEfficacyPage;
